import { CronExpressionParser } from 'cron-parser';

const MIN_SYNC_INTERVAL_MS = 24 * 60 * 60 * 1000;
const SAMPLE_ITERATIONS = 14;

type CronScheduledSyncValidation = { valid: true } | { message: string; valid: false };

export function validateCronScheduledSync(expr?: string): CronScheduledSyncValidation {
  if (expr == null || expr === 'None') {
    return { valid: true };
  }

  try {
    const parser = CronExpressionParser.parse(expr, { currentDate: new Date(0), tz: 'UTC' });
    let prev = parser.next().getTime();
    let minGapMs = Infinity;

    for (let i = 0; i < SAMPLE_ITERATIONS; i++) {
      const next = parser.next().getTime();
      minGapMs = Math.min(minGapMs, next - prev);
      prev = next;
    }

    if (minGapMs < MIN_SYNC_INTERVAL_MS) {
      return { message: 'Sync schedule must be at least 24 hours apart', valid: false };
    }

    return { valid: true };
  } catch {
    return { message: 'Invalid cron expression', valid: false };
  }
}
